import { render } from "./SimulationTemplate.vue?vue&type=template&id=7285968d&bindings={}"
import script from "./SimulationTemplate.vue?vue&type=script&lang=ts"
export * from "./SimulationTemplate.vue?vue&type=script&lang=ts"

import "./SimulationTemplate.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script